<template>
  <van-popup class="topart"  position="top" v-model="show">
    <div v-if="show" class="topnavbox" @click="topnavPlay">
      <van-cell-group class="topnav">
        <router-link :to="{path: '/eindex', query: {gid:gid}}" tag="div" class="van-cell van-hairline"><span>
          <i class="van-icon iconfont icon-liwu1 theme-col"></i>
          兑换专区</span></router-link>
        <router-link :to="{path: '/eorderlist', query: {gid:gid}}" tag="div" class="van-cell van-hairline"><span>
          <i style="font-size: .24rem" class="van-icon iconfont icon-dingdan  theme-col"></i>
          我的订单</span></router-link>
        <div  style="border-top: 1px solid #fff" @click="outLogin" tag="div" class="van-cell van-hairline"><span>
          <i class="van-icon iconfont icon-zhuxiao  theme-col"></i>
          注销</span></div>

      </van-cell-group>
    </div>
  </van-popup>
</template>

<script>
  export default {
    name: "topnav",
    data() {
      return {
        show: false,
        gid:this.$route.query.gid
      }
    },
    methods:{
      topnavPlay:function () {
        this.show = !this.show
      },
      outLogin:function () {
        localStorage.clear();
        this.$router.push({ name: 'Elogin',query:{gid:this.gid} })
      }
    }
  }
</script>

<style lang="less" scoped>
  .topart{
    overflow: inherit;
    .topnavbox{
      position: fixed;
      top: 46px;
      right: 15px;
      z-index: 10;
      [class*=van-hairline]::before{
        height: 0;
        width: 0;
      }
      .van-cell:not(:last-child)::after {
        border-bottom: 0px solid #ebedf0;
      }
      .topnav{
        border-radius: 6px;
        background: #fff;
        overflow: hidden;
        z-index: 10;
        .van-cell{
          padding: 7px 10px;
          background-color:transparent;
          color: #333;
          span{
            width: 100%;
            display: inline-block;
            text-align: left;
          }
        }
        .van-cell:not(:last-child)::after{
          right: 15px;
        }
        .van-icon{
          vertical-align: middle;
          font-size: 0.32rem;
          margin-right: 5px;
        }
      }
    }
    .topnavbox::before{
      content: '';
      position: absolute;
      width: 0px;
      height: 0px;
      border-width: 20px;
      border-style: solid;
      border-color: #fff transparent transparent #fff;
      right: 17px;
      top: -20px;
      z-index: 1;
      -webkit-transform: rotate(45deg);
      transform: rotate(-160deg);
      z-index: 5;
    }
    .van-cell:not(:last-child)::after {
      bottom: -15px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/topnav1.vue